import styled from "styled-components"; 

export const FormPromptWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const LabelForm = styled.span`
    width: 100%;
    color: ${props => props.theme.colors.black};
    ${props => props.theme.fonts.variant.regular()};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;
